<template>
  <button type="button" class="kv-tab" :class="{ 'kv-tab--active': isActive }" @click="selectTabHandler">
    <slot></slot>
  </button>
</template>

<script>
const TabsKey = 'kv-tabs';

export default {
  name: 'KvTab',
  props: {
    value: { type: [String, Number], required: true },
  },
  inject: [TabsKey],
  computed: {
    isActive() {
      return this[TabsKey].activeTab.value === this.value;
    },
  },
  methods: {
    selectTabHandler() {
      this[TabsKey].selectTab(this.value);
    },
    scrollIntoView() {
      this.$nextTick(() => {
        const el = this.$el;
        if (!el) return;

        // Only scroll the tab header strip, never the whole page/layout.
        const scroller = el.closest ? el.closest('.kv-tabs-scroll-area') : null;
        if (!scroller || !scroller.scrollTo) {
          if (el.scrollIntoView) {
            el.scrollIntoView({ behavior: 'smooth', inline: 'nearest', block: 'nearest' });
          }
          return;
        }

        const elRect = el.getBoundingClientRect();
        const scrollerRect = scroller.getBoundingClientRect();

        const elCenterInScroller =
          (elRect.left - scrollerRect.left) + scroller.scrollLeft + (elRect.width / 2);
        let targetLeft = elCenterInScroller - (scrollerRect.width / 2);

        const maxLeft = Math.max(0, scroller.scrollWidth - scrollerRect.width);
        targetLeft = Math.max(0, Math.min(maxLeft, targetLeft));

        scroller.scrollTo({ left: targetLeft, behavior: 'smooth' });
      });
    }
  },
  watch: {
    // Monitora se esta aba se tornou a ativa
    isActive: {
      handler(newValue) {
        if (newValue) {
          this.scrollIntoView();
        }
      },
      // immediate: true garante que o scroll aconteça também 
      // ao carregar a página se a aba já começar ativa
      immediate: true
    }
  },
};
</script>

<style scoped lang="less">
.kv-tab {
  padding: 12px 16px;
  /* Padding confortável */
  border: none;
  background: none;
  cursor: pointer;

  /* Estilo da borda inferior */
  border-bottom: 2px solid transparent;
  transition: all 0.3s;

  font-weight: 500;
  color: #9DA4AE;

  /* CRÍTICO: Impede quebra de linha */
  white-space: nowrap;

  /* Centralizar texto dentro da tab esticada */
  display: flex;
  align-items: center;
  justify-content: center;

  /* O grid controla a largura, mas width: 100% garante preenchimento da célula */
  width: 100%;

  &:hover {
    background-color: #fafafa;
    color: #555;
  }

  &.kv-tab--active {
    border-bottom-color: #2AAA4C;
    color: #2AAA4C;
  }
}
</style>